import React, { useState } from 'react';
import PlayerCafeMark from '../playerCafeMark/playerCafeMark';
import { styles } from './styles';

export default function PlayerCafeBrand(props: {
  href: string;
  homeLabel: string;
}): JSX.Element {

  const [isMakerHovered, setIsMakerHovered] = useState(false);

  return (
    <div style={styles.brand}>
      <a href={props.href} style={styles.markLink} tabIndex={-1} aria-hidden>
        <PlayerCafeMark size={30} />
      </a>
      <span className="pc-brand-text" style={styles.text}>
        <a href={props.href} style={styles.wordmark} aria-label={props.homeLabel}>PlayerCafe</a>
        <span style={styles.endorsement}>
          by{' '}
          <a
            href="https://novaeon.io"
            style={isMakerHovered ? { ...styles.endorsementLink, ...styles.endorsementLinkHovered } : styles.endorsementLink}
            onMouseEnter={() => setIsMakerHovered(true)}
            onMouseLeave={() => setIsMakerHovered(false)}
          >
            Novaeon
          </a>
        </span>
      </span>
    </div>
  );

}
